"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _exchangeUiPortalsCommon = require("@mulesoft/exchange-ui-portals-common");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _mapping = _interopRequireDefault(require("./mapping.json"));
var RESTApiMatch = function RESTApiMatch(_ref) {
  var name = _ref.name,
    highlight = _ref.highlight;
  return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
    className: _exchangeUiPortalsCommon.AssetCard.styles.rowTitle
  }, name), /*#__PURE__*/_react.default.createElement("td", {
    className: _exchangeUiPortalsCommon.AssetCard.styles.rowContent
  }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, highlight)));
};
RESTApiMatch.propTypes = {
  name: _propTypes.default.string.isRequired,
  highlight: _propTypes.default.string.isRequired
};
var RESTApiCard = function RESTApiCard(props) {
  var highlight = props.highlight;
  var renderSpecification = _react.default.useCallback(function () {
    if (!highlight || !highlight.specificationLength) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("table", {
      className: _exchangeUiPortalsCommon.AssetCard.styles.matchesTable,
      "data-test-id": "asset-card-specification"
    }, /*#__PURE__*/_react.default.createElement("tbody", null, _mapping.default.map(function (mapping) {
      if (!highlight[mapping.node]) {
        return null;
      }
      if (!highlight[mapping.node][mapping.key]) {
        return null;
      }
      if (Array.isArray(highlight[mapping.node][mapping.key])) {
        return highlight[mapping.node][mapping.key].map(function (highlightedProperty, index) {
          return /*#__PURE__*/_react.default.createElement(RESTApiMatch, {
            key: "".concat(mapping.node, "-").concat(mapping.key, "-").concat(index),
            name: mapping.name,
            highlight: highlightedProperty
          });
        });
      }
      return /*#__PURE__*/_react.default.createElement(RESTApiMatch, {
        key: "".concat(mapping.node, "-").concat(mapping.key),
        name: mapping.name,
        highlight: highlight[mapping.node][mapping.key]
      });
    })));
  }, [highlight]);
  var getMatches = _react.default.useCallback(function (cardMatches) {
    var specification = renderSpecification();
    if (!specification) {
      return cardMatches;
    }
    return [{
      title: "Specification (".concat(highlight.specificationLength, ")"),
      content: specification,
      id: 'rest-api'
    }].concat((0, _toConsumableArray2.default)(cardMatches));
  }, [renderSpecification]);
  return /*#__PURE__*/_react.default.createElement(_exchangeUiPortalsCommon.AssetCard, (0, _extends2.default)({}, props, {
    getMatches: getMatches
  }));
};
RESTApiCard.propTypes = {
  highlight: _propTypes.default.object
};
var _default = exports.default = RESTApiCard;
//# sourceMappingURL=AssetCard.js.map